"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useNotifications;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useNotifications() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var notifications = _ref.notifications;
    return notifications;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VOb3RpZmljYXRpb25zLnRzIl0sIm5hbWVzIjpbInVzZU5vdGlmaWNhdGlvbnMiLCJub3RpZmljYXRpb25zIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBR2UsU0FBU0EsZ0JBQVQsR0FBOEM7QUFDM0QsU0FBTyxDQUFDLHNDQUFZO0FBQUEsUUFBR0MsYUFBSCxRQUFHQSxhQUFIO0FBQUEsV0FBdUJBLGFBQXZCO0FBQUEsR0FBWixDQUFELENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuaW1wb3J0IE5vdGlmaWNhdGlvbiBmcm9tICcuLi90eXBlcy9Ob3RpZmljYXRpb24nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VOb3RpZmljYXRpb25zKCk6IFtOb3RpZmljYXRpb25bXV0ge1xuICByZXR1cm4gW3VzZVNlbGVjdG9yKCh7IG5vdGlmaWNhdGlvbnMgfSkgPT4gbm90aWZpY2F0aW9ucyldO1xufVxuIl19